import { FirebaseError } from 'firebase/app';
import { doc, onSnapshot } from 'firebase/firestore';
import { useEffect, useState } from 'react';

import { db } from '../../../config';
import { UserProfileFirebaseResponse } from './types';

const COLLECTION_PATH = 'users';

interface UseGetMyAccountDataResult {
    data: UserProfileFirebaseResponse | null;
    isLoading: boolean;
    error: FirebaseError | null;
}

export const useGetMyAccountData = (
  id: string | null | undefined,
): UseGetMyAccountDataResult => {
  const [data, setData] = useState<UserProfileFirebaseResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<FirebaseError | null>(null);

  useEffect(() => {
    if (!id) {
      setData(null);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);

    const documentRef = doc(db, COLLECTION_PATH, id);

    const unsubscribe = onSnapshot(
      documentRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const docData = snapshot.data();
          setData({
            id: snapshot.id,
            name: docData.name,
            surname: docData.surname,
            profilePicture: docData.profilePicture,
            email: docData.email,
            language: docData.language,
            notificationPreferences: docData.notificationPreferences,
          });
        } else {
          setData(null);
        }
        setIsLoading(false);
      },
      (err) => {
        setError(new FirebaseError('unknown', err.message));
        setIsLoading(false);
      },
    );

    // eslint-disable-next-line consistent-return
    return () => unsubscribe();
  }, [id]);

  return { data, isLoading, error };
};
